export default __webpack_public_path__ + "static/media/wallet.1cc7f223.svg";